let employeePositions = [
  'CEO',
  'Comercial',
  'Compras',
  'Financiero',
  'IT',
  'Operaciones',
  'RRHH',
  'Servicio al Cliente',
];

export default {
  pop_business_employee(state) {
    state.business.b2bEmployees.pop();
  },
  put_business_employee(state, businessEmployee) {
    if (state.business.b2bEmployees.length > 0) {
      let b2bEmployees = state.business.b2bEmployees;
      if (b2bEmployees[b2bEmployees.length - 1].name === businessEmployee.name && b2bEmployees[b2bEmployees.length - 1].role === businessEmployee.role) {
        state.business.b2bEmployees = b2bEmployees.map((employee, index) => {
          if (index === b2bEmployees.length - 1) {
            return {
              ...employee,
              ...businessEmployee
            };
          } else {
            return employee;
          }
        });
      } else {
        state.business.b2bEmployees.push(businessEmployee);
      }
    } else {
      state.business.b2bEmployees.push(businessEmployee);
    }
  },
  set_business(state, business) {
    state.business = business;
  },
  set_assigned_companies(state, companies) {
    state.business = {...state.business, assignedCompanies: companies }
    // state.business.assignedCompanies = companies;
  },
  set_company_profile(state, companyProfile) {
    if (companyProfile.required_positions === undefined) {
      companyProfile.required_positions = employeePositions;
      companyProfile.not_required_positions = [];
    }
    state.business.companyProfile = companyProfile;
  },
  set_company_profile_employees(state, employees) {
    if (state.business.companyProfile)
      state.business.companyProfile.employees = employees;
  },
  set_company_profile_leads(state, leads) {
    if (state.business.companyProfile) {
      state.business.companyProfile.leads = leads;
      // console.log('se settearon los leads');
    }
  },
  set_company_profile_positions(state, positions) {
    let notRequired = positions.filter(position => employeePositions.indexOf(position) == -1);
    if (state.business.companyProfile) {
      state.business.companyProfile.required_positions = positions;
      state.business.companyProfile.not_required_positions = notRequired;
    }
  },
  set_leads_summary(state, leadsSummary) {
    state.business = {...state.business, leadsSummary};
    // state.business.leadsSummary = leadsSummary;
  },
  set_token(state, token) {
    state.api.defaults.headers.common["Authorization"] = "Bearer " + token;
    state.token = token;
  },
  set_user(state, user) {
    state.user = user;
  },
  set_loading(state, status) {
    state.loading = status;
  },
  set_routes(state, status) {
    state.routes = status;
  },
  set_data(state, data) {
    let name = data.name;
    let info = data.info;

    if (name) {
      state.extraData[name] = info;
    }
  },
  update_lead(state, newLead) {
    if (state.business.companyProfile) {
      state.business.companyProfile = {
        ...state.business.companyProfile,
        leads: state.business.companyProfile.leads.map(lead => {
          if (lead.id === newLead.id) {
            return newLead;
          } else {
            return lead;
          }
        }),
      }
    }
  }
};
